import React from 'react'
function HomeCarousel () {
  return (
    <>
      <div id='carouselExampleIndicators' className='carousel slide' data-ride='carousel'>
        <ol className='carousel-indicators'>
          <li data-target='#carouselExampleIndicators' data-slide-to='0' className='active' />
          <li data-target='#carouselExampleIndicators' data-slide-to='1' />
          <li data-target='#carouselExampleIndicators' data-slide-to='2' />
        </ol>
        <div className='carousel-inner'>
          <div className='carousel-item active'>
            <img
              className='d-block w-100'
              src='https://images.unsplash.com/photo-1505740420928-5e560c06d30e?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MXx8aGVhZHBob25lc3xlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&w=1000&q=80'
              style={{ height: '94vh' }}
              alt='First slide'
            />
          </div>
          <div className='carousel-item'>
            <img
              className='d-block w-100'
              src='https://images.unsplash.com/photo-1582133456304-2f5cb1c2afbb?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80'
              style={{ height: '94vh' }}
              alt='Second slide'
            />
          </div>
          <div className='carousel-item'>
            <img className='d-block w-100' src='https://wallpaperaccess.com/full/191366.jpg' style={{ height: '94vh' }} alt='Third slide' />
          </div>
        </div>
        <a className='carousel-control-prev' href='#carouselExampleIndicators' role='button' data-slide='prev'>
          <span className='carousel-control-prev-icon' aria-hidden='true' />
          <span className='sr-only'>Previous</span>
        </a>
        <a className='carousel-control-next' href='#carouselExampleIndicators' role='button' data-slide='next'>
          <span className='carousel-control-next-icon' aria-hidden='true' />
          <span className='sr-only'>Next</span>
        </a>
      </div>
    </>
  )
}
export default HomeCarousel
